import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VoxelAutocompleteComponent } from '@voxel/components';
import { NavigationService } from '../../shared/services/navigation/navigation-service.service';
import { BaseComponent } from '../../shared/components/base-component';
import { findInArray, getValueProperty, memoize, setValueProperty } from '../../shared/helpers/functions.helpers';
import { ApplicationService } from '../../shared/services/application/application.service';
import { CatalogService, EPersonType } from '../../shared/services/catalogs/catalog.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { EVENT } from '../../shared/constants/dali.constants';

export interface ISolicitationSubtype {
  id: string,
  name: string,
  description?: string,
  typeId?: string,
  celulaId?: string,
  parameters?: Array<{ key: string, value: string }>
}

export interface ISolicitationType {
  id: string,
  name: string,
  subtypes: Array<ISolicitationSubtype>,
  celulaId?: string,
  parameters?: Array<{ key: string, value: string }>
}

@Component({
  selector: 'app-solicitation-modal-typification',
  templateUrl: './solicitation-modal-typification.component.html',
  styleUrls: ['./solicitation-modal-typification.component.scss']
})
export class SolicitationModalTypificationComponent extends BaseComponent implements OnInit {
  stepsInformation: any;
  @ViewChild('autocomplete') autocomplete!: VoxelAutocompleteComponent;

  @Input() componentStart: any;

  form: FormGroup = this.fb.group({
  });
  chkDisable: any;


  /**
 * Contiene los textos y etiquetas
 */
  CONTENT_BOUNDS: any[] | any;

  /**
* Permite establecer si se debe mostrar en pantalla la modal de tipos de solicitud
*/
  modalAShow = false;

  /**
   * Almacena los tipos de solicitud
   */
  solicitationTypes: Array<ISolicitationType> = [];
  solicitationTypesList: Array<ISolicitationType> = [];
  solicitationTypesFilter: Array<{
    id: string,
    name: string,
    type: string,
    parentId?: string
  }> = []
  _solicitationTypes: Array<{ name: string }> = [];
  filter: string = '';
  loading: boolean = false;

  constructor(
    private readonly cps: CopyService,
    private readonly catalog: CatalogService,
    private readonly controlContainer: ControlContainer,
    private readonly fb: FormBuilder,
    public app: ApplicationService,
    private link: LinkupService,
    public navigator: NavigationService

  ) {
    super(app, link, "solicitation-modal-typification")
  }

  ngOnInit(): void {
    this.loadStaticValues();
    this.initControls();
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    this.loading = true;
    this.CONTENT_BOUNDS = await this.cps.getCopy("solicitation-modal-typificacion");
    this.solicitationTypes = await this.catalog.getCelulaTypes();
    //await this.catalog.getCelulaTypeSubtypes();
    this.solicitationTypes = await Promise.all(this.solicitationTypes.map(async (item) => {

      let subtypes = await this.catalog.getCelulaTypeSubtypes(item.celulaId, item.id);

      subtypes = subtypes.map((subtype: ISolicitationSubtype) => {

        const PARAMETERS = getValueProperty(subtype, 'parameters', []);
        const DESCRIPTION_PARAMETER = findInArray(PARAMETERS, 'key', 'description');
        subtype['description'] = getValueProperty(DESCRIPTION_PARAMETER, 'value');
        return subtype;
      });
      return {
        ...item,
        subtypes: subtypes
      }
    }));

    this.solicitationTypesList = this.solicitationTypes;
    this.solicitationTypesFilter = [];
    this.solicitationTypesList.forEach(type => {
      this.solicitationTypesFilter.push(
        {
          id: type.id,
          name: type.name,
          type: 'TYPE'
        }
      );

      let subtypes = getValueProperty(type, 'subtypes', []);
      subtypes.forEach((subtype: ISolicitationSubtype) => {
        const subtypeItem = {
          id: subtype.id,
          name: subtype.name,
          description: subtype.description,
          parentId: type.id,
          type: 'SUBTYPE'
        };
        this.solicitationTypesFilter.push(subtypeItem);
      });
    });

    this.solicitationTypesFilter.sort((a, b) => {
      let fa = a.name.toLowerCase(),
        fb = b.name.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    this.loading = false;
  }

  /**
   * Permite inicializar los campos del formulario en el componente
   */
  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }
    this.form = new FormGroup({
      'filter': new FormControl('', Validators.nullValidator)
    });
    //this.form.addControl('filter', new FormControl());
    this.form.updateValueAndValidity();
  }

  /**
     * Establece el valor de modalAShow a verdadero para mostrar
     * la modal de tipos de solicitud en pantalla
     */
  onShowModal() {
    if (this.navigator.currentStep.key == "bank-start" || this.navigator.currentStep.key == "requirements-start") {
      let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv2E2setData.pv2E2transactionName.path}",
          "value": EVENT.pv2E2setData.pv2E2transactionName.value
        },
        {
          "name": "{EVENT.pv2E3setData.pv2E3transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);

    }
    else if (this.navigator.currentStep.key == "solicitation-data") {

      let eventSetting = this.getSetting("analytics", "trackEvent.pv4e1", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv4E1setData.pv4E1transactionName.path}",
          "value": EVENT.pv4E1setData.pv4E1transactionName.value
        },
        {
          "name": "{EVENT.pv4E1setData.pv4E1transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);

    }
    this.modalAShow = true
  };

  /**
     * Se ejecuta cuando se emite el evento de cierre de la modal
     * @param event
     */
  onCloseModal(event: any) {
    this.modalAShow = false;
  }


  /**
   * Evento principal de cierre
   * @param $event
   */
  onCloseEvent($event: any) {
  }

  cleanFilter() {
    this.filter = '';
    this.autocomplete.setValue(null);
    this.autocomplete.resetValue();
    this.autocomplete.resetSelection();
    this.solicitationTypesList = this.solicitationTypes;
  }

  optionSelected(event: any) {
    this.loading = true;

    const { selectedOptionValue } = event;

    if (selectedOptionValue) {
      const { type, id, parentId } = selectedOptionValue;

      if (type === 'SUBTYPE') {

        let types: ISolicitationType = findInArray(this.solicitationTypesList, 'id', parentId);
        types.subtypes = types.subtypes.filter((subtype) => {
          return subtype.id === id
        });
        this.solicitationTypesList = [types];
      } else {
        this.solicitationTypesList = this.solicitationTypesList
          .filter((type: ISolicitationType) => {
            return type.id === id;
          });
      }
    } else {
      this.solicitationTypesList = this.solicitationTypes;
    }
    this.loading = false;
  }

  get linkSetting() {
    return this.getSetting("link_section", undefined, {});
  }

  @memoize()
  async textDescriptionType(type: ISolicitationType) {
    let text = getValueProperty(type, 'name', '');
    let parameters = getValueProperty(type, 'parameters', []);
    const PERSON_TYPES_PARAMETER = findInArray(parameters, 'key', 'personType');
    const PERSON_TYPES: string = getValueProperty(PERSON_TYPES_PARAMETER, 'value', `${EPersonType.PERSON_TYPE_NAT}_${EPersonType.PERSON_TYPE_JUR}`);
    const CUSTOMER_TYPES = await this.catalog.customerTypes;
    let personTypes = PERSON_TYPES.split('_');
    if (personTypes) {
      text += ' - ';
      let personTypesName = [];
      for (let personType of personTypes) {
        const CUSTOMER_TYPE = findInArray(CUSTOMER_TYPES, 'id', personType);
        personTypesName.push(getValueProperty(CUSTOMER_TYPE, 'desc', personType));
      }
      text += personTypesName.join(' y ');
    }
    return text;
  }

}
